package com.elan.edubridge.shared.domain.usecase

import com.elan.edubridge.shared.domain.model.AttendanceTimelineEntry
import com.elan.edubridge.shared.domain.model.SessionState
import com.elan.edubridge.shared.domain.repository.EduConnectRepository

/**
 * 학생·학부모 공용 개인 타임라인(§4.3). 회원 뷰 `/app/me`와 모바일 홈이 같은 read model을 쓴다.
 *
 * **격리는 경로가 보장한다** — 조회는 `users/{uid}/attendanceTimeline`만 본다.
 * 세션 계정 id 외의 uid로는 조회할 수 없으므로 다른 학생의 데이터가 나올 경로가 없다.
 * 학부모는 [subjectStudentId]로 자녀를 고르고, 해지된 링크의 문서는 트리거가 이미 지웠다(§4.4).
 *
 * 이름은 계획 §7 S1을 따른다. M1 웹은 1회 조회로 충분해 `suspend` + 목록으로 두고,
 * 실시간 구독이 필요해지는 M2에서 `Flow` 반환을 추가한다(기존 함수는 바꾸지 않는다).
 */
class ObserveMyTimelineUseCase(
    private val repository: EduConnectRepository,
) {
    /**
     * @param academyId null이면 전 학원. 자녀가 서로 다른 학원에 다닐 수 있다.
     * @param subjectStudentId null이면 관찰 가능한 대상 전원.
     */
    suspend operator fun invoke(
        session: SessionState,
        academyId: String?,
        subjectStudentId: String?,
        limit: Int,
    ): List<AttendanceTimelineEntry> {
        val userId = session.account?.id ?: return emptyList()
        return repository.myTimeline(userId, academyId, subjectStudentId, limit)
    }
}
